export type TButtonArrowProps = {
  direction?: TArrowDirection;
  disabled?: boolean;
  className?: string;
  color?: string;
  scale?: number;
  onClick?: () => void;
};

export type TArrowDirection = 'up' | 'right' | 'down' | 'left';

export enum E_ARROW_TEXT {
  right = '→',
  up = '↑',
  down = '↓',
  left = '←',
}
